/* istanbul ignore file */
import { enforceBasePath, loadMfsEntrypoints } from '@im/ui-lib/mf-utils';
import { markAppShellPhase } from './metrics/app-shell-phase-timings';
import { startMainThreadBlockingTracking } from './metrics/main-thread-blocking';
import { startPageVisibilityTracking } from './metrics/page-visibility';
import { mfNames } from './mfNames';

enforceBasePath('cep', 'app');
startPageVisibilityTracking();
startMainThreadBlockingTracking();

// Start measuring the bootstrap phase of the app shell
const bootstrapStart = performance.now();
const isLocalDev = globalThis.location.origin.includes('://local');
markAppShellPhase('bootstrap_start_ms', bootstrapStart);

(async () => {
  await loadMfsEntrypoints('cep', ['mf_core', 'mf_shared'].concat(mfNames));
  markAppShellPhase('mfe_entrypoints_ready_ms');

  // Load the main app mount code.
  await import(
    /* webpackChunkName: "app-mount" */
    './app-mount'
  );

  if (!isLocalDev) {
    // Load Datadog RUM only in non-local development environments to avoid duplicate SDK load.
    void import(
      /* webpackChunkName: "data-dog-rum" */
      './data-dog-rum'
    ).catch(() => {
      console.warn('Failed to load Datadog RUM');
    });
  }
})();

export {}; // Make file an ES module.
